module.exports = __webpack_public_path__ + "static/media/media2.067b7f25.png";